import { Component } from '@angular/core';

@Component({
  selector: 'app-form-permission',
  template: `
    <p>
      form-permission works!
    </p>
  `,
  styles: ``
})
export class FormPermissionComponent {

}
